<script>
import StakeholderCategoryService from "@/services/StakeholderCategoryService";

export default {
    props: {
        projectId: {}
    },
    data() {
        return {
            loading: true,
            saving: false,
            errors: {},
            entity: {
                id: null,
                project_id: null,
                name: null,
                name_col_active: "0",
                title_col_active: "0",
                address_col_active: "0",
                phone_col_active: "0",
                email_col_active: "0",
                note_col_active: "0",
                custom_string_col_active: "0",
                custom_number_col_active: "0",
                custom_string_col_name: null,
                custom_number_col_name: null
            },
            customColumns: []
        };
    },
    created() {
        this.entity.project_id = this.projectId;
        this.loading = false;
    },
    methods: {
        async saveForm() {
            try {
                this.saving = true;
                const payload = {
                    ...this.entity,
                    custom_columns: this.customColumns
                        .filter(c => c.name && c.name.trim())
                        .map((c, i) => ({
                            name: c.name.trim(),
                            sort_order: i + 1
                        }))
                };
                await StakeholderCategoryService.POST(payload);
                this.$emit("close-reload");
            } catch (e) {
                this.errors = e.response.data.errors;
            }

            this.saving = false;
        },
        addCustomColumn() {
            this.customColumns.push({ name: "" });
        },
        removeCustomColumn(index) {
            this.customColumns.splice(index, 1);
        }
    }
};
</script>

<template>
    <modal
        :show="true"
        @close="$emit('close')"
        class="budget-modal"
        :loading="loading"
    >
        <template slot="header">
            {{ $t("stakeholders.create_category") }}
        </template>

        <template slot="default">
            <FormulateForm v-model="entity" @submit="saveForm" :errors="errors">
                <div class="row">
                    <div class="col-12">
                        <FormulateInput
                            type="text"
                            name="name"
                            :label="$t('stakeholders.category_name')"
                            :validation-name="$t('stakeholders.category_name')"
                            validation="required"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <label class="form-control-label">{{
                            $t("stakeholders.select_columns")
                        }}</label>
                        <div class="row">
                            <div class="col-3">
                                <label>
                                    <input
                                        v-model="entity.name_col_active"
                                        class="mr-2"
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                    />
                                    <small>{{
                                        $t("stakeholders.hdr_name")
                                    }}</small> </label
                                ><br />
                                <label>
                                    <input
                                        v-model="entity.title_col_active"
                                        class="mr-2"
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                    />
                                    <small>{{
                                        $t("stakeholders.hdr_title")
                                    }}</small> </label
                                ><br />
                                <label>
                                    <input
                                        v-model="entity.address_col_active"
                                        class="mr-2"
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                    />
                                    <small>{{
                                        $t("stakeholders.hdr_address")
                                    }}</small> </label
                                ><br />
                                <label>
                                    <input
                                        v-model="entity.phone_col_active"
                                        class="mr-2"
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                    />
                                    <small>{{
                                        $t("stakeholders.hdr_phone")
                                    }}</small>
                                </label>
                            </div>
                            <div class="col-9">
                                <label>
                                    <input
                                        v-model="entity.email_col_active"
                                        class="mr-2"
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                    />
                                    <small>{{
                                        $t("stakeholders.hdr_email")
                                    }}</small> </label
                                ><br />
                                <label>
                                    <input
                                        v-model="entity.note_col_active"
                                        class="mr-2"
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                    />
                                    <small>{{
                                        $t("stakeholders.hdr_note")
                                    }}</small> </label
                                ><br />
                                <label>
                                    <input
                                        v-model="
                                            entity.custom_string_col_active
                                        "
                                        class="mr-2"
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                    />
                                    <small>{{
                                        $t("stakeholders.hdr_custom_string")
                                    }}</small>
                                    <input
                                        v-model="entity.custom_string_col_name"
                                        class="small-input ml-2"
                                        type="text"
                                        :placeholder="
                                            $t('stakeholders.type_title')
                                        "
                                        true-value="1"
                                        false-value="0"
                                    />
                                    <v-custom-error
                                        :errors="
                                            errors.custom_string_col_active
                                        "
                                        v-if="errors.custom_string_col_active"
                                    /> </label
                                ><br />
                                <label>
                                    <input
                                        v-model="
                                            entity.custom_number_col_active
                                        "
                                        class="mr-2"
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                    />
                                    <small>{{
                                        $t("stakeholders.hdr_custom_number")
                                    }}</small>
                                    <input
                                        v-model="entity.custom_number_col_name"
                                        class="small-input ml-2"
                                        type="text"
                                        :placeholder="
                                            $t('stakeholders.type_title')
                                        "
                                    />
                                    <v-custom-error
                                        :errors="
                                            errors.custom_number_col_active
                                        "
                                        v-if="errors.custom_number_col_active"
                                    />
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12">
                        <label class="form-control-label">{{
                            $t("stakeholders.custom_columns")
                        }}</label>
                        <div
                            v-for="(col, index) in customColumns"
                            :key="index"
                            class="d-flex align-items-center mb-2"
                        >
                            <input
                                v-model="col.name"
                                type="text"
                                class="form-control form-control-sm"
                                :placeholder="$t('stakeholders.column_name')"
                                style="max-width: 300px"
                            />
                            <base-button
                                type="danger"
                                size="sm"
                                outline
                                class="ml-2"
                                @click="removeCustomColumn(index)"
                            >
                                <i class="far fa-times"></i>
                            </base-button>
                        </div>
                        <base-button
                            type="secondary"
                            size="sm"
                            outline
                            @click="addCustomColumn"
                        >
                            <i class="far fa-plus"></i>
                            {{ $t("stakeholders.add_column") }}
                        </base-button>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col text-right">
                        <base-button
                            type="secondary"
                            :outline="true"
                            @click="$emit('close')"
                            >{{ $t("cancel") }}</base-button
                        >
                        <base-button
                            type="primary"
                            :loading="saving"
                            native-type="submit"
                            >{{ $t("save") }}</base-button
                        >
                    </div>
                </div>
            </FormulateForm>
        </template>
    </modal>
</template>

<style scoped>
.small-input {
    font-size: small;
    width: 8rem;
}
</style>
